<template>
  <AddFamilyTemplate
    :header="header"
    :internal="false"
  >
    <template #content>
      <FamilyReporter ref="form" />
    </template>
    <template #actions>
      <FamilyReporterButtons @validate="validateData" />
    </template>
  </AddFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
import FamilyReporter from '@/components/addFamily/external/FamilyReporter';
import FamilyReporterButtons from '@/components/addFamily/external/FamilyReporterButtons';

export default {
    name: 'FamilyReporterExternal',
    components: { FamilyReporterButtons, FamilyReporter, AddFamilyTemplate },
    computed: {
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('outside_family.header_subtitles.person_data'),
                redirect: true
            };
        }
    },
    methods: {
        validateData () {
            this.$refs.form.submit();
        }
    }
};
</script>

<style scoped></style>
